import jwt from '@/auth/jwt/useJwt'
import { computed, ref } from '@vue/composition-api'
import TicketsConstants from './TicketsConstants'

export default function Tickets() {
  const route = 'tickets'
  const ticket = ref({
    sales_channel: 1,
    show_sale_date_status: true,
    visibility: 1,
    price_type: 2,
    delivery_method: 1,
    sale_start_date: '',
    sale_start_time: '',
    sale_end_date: '',
    sale_end_time: '',
  })

  const formattedTicket = computed(() => {
    const { price, ...ticketWithoutPrice } = ticket.value
    return {
      ...ticketWithoutPrice,
      delivery_method: [ticketWithoutPrice.delivery_method],
      ...(ticketWithoutPrice.price_type === TicketsConstants.price_type.Paid ? { price: ticket.value.price } : {}),
    }
  })

  const mapTicketConst = selectedTicket => ({
    ...selectedTicket,
    delivery_method: TicketsConstants.delivery_method[selectedTicket.delivery_method],
    price_type: TicketsConstants.price_type[selectedTicket.price_type],
    ...(selectedTicket.price_type === TicketsConstants.price_type.Paid ? { price: selectedTicket.price } : {}),
    sales_channel: TicketsConstants.sales_channel[selectedTicket.sales_channel],
    visibility: TicketsConstants.visibility[selectedTicket.visibility],
    show_sale_date_status: selectedTicket.show_sale_status,
  })

  const getTicketsRequest = params => jwt.axiosIns.get(route, { params }).then(res => res).catch(() => [])

  const getTicketRequest = id => jwt.axiosIns.get(`${route}/${id}`).then(res => res).catch(() => [])

  const addTicketRequest = eventId => jwt.axiosIns.post(route, { ...formattedTicket.value, event_id: eventId }).then(res => res)

  const copyTicketRequest = () => jwt.axiosIns.post(route, formattedTicket.value).then(res => res)

  const updateTicketRequest = () => jwt.axiosIns.put(`${route}/${ticket.value.id}`, formattedTicket.value).then(res => res)

  const deleteTicketRequest = id => jwt.axiosIns.delete(`${route}/${id}`).then(res => res)

  return {
    ticket, getTicketsRequest, getTicketRequest, addTicketRequest, copyTicketRequest, updateTicketRequest, deleteTicketRequest, mapTicketConst,
  }
}
